export const WEEKDAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

export function monthRange(year, month) {
  const prefix = `${year}-${String(month).padStart(2, '0')}`;
  return { dataInicial: `${prefix}-01`, dataFinal: `${prefix}-${new Date(year, month, 0).getDate()}` };
}

function number(value, required = false) {
  if (value == null || value === '') {
    if (required) throw new Error('A API retornou valor total ausente.');
    return null;
  }
  const parsed = typeof value === 'string' && value.includes(',')
    ? Number(value.replace(/\./g, '').replace(',', '.')) : Number(value);
  if (!Number.isFinite(parsed)) throw new Error('A API retornou um valor numérico inválido.');
  return parsed;
}

export function recordDate(row) {
  let year, month, day;
  if (typeof row.data === 'string') {
    const iso = /^(\d{4})-(\d{2})-(\d{2})(?:T|$)/.exec(row.data);
    const br = /^(\d{2})\/(\d{2})\/(\d{4})(?:\s|$)/.exec(row.data);
    if (iso) [, year, month, day] = iso.map(Number);
    else if (br) [, day, month, year] = br.map(Number);
  }
  if (year == null) { year = number(row.ano); month = number(row.mes); day = number(row.dia); }
  const date = new Date(year, month - 1, day);
  if (![year, month, day].every(Number.isInteger) || date.getFullYear() !== year
      || date.getMonth() !== month - 1 || date.getDate() !== day) {
    throw new Error('A API retornou uma data inválida para o indicador.');
  }
  return { year, month, day };
}

export function normalizeShipping(row) {
  return {
    ...recordDate(row),
    familia: String(row.familia ?? '').trim() || 'Não informada',
    fabricante: String(row.fabricante ?? '').trim() || 'Não informado',
    classificacao: row.classificacao == null ? null : String(row.classificacao).trim() || null,
    valorTotal: number(row.valorTotal, true),
    valorFrete: number(row.valorfretePago),
    valorLiquido: number(row.valorliquido),
  };
}

export function filterShipping(rows, { year, month, family = '', manufacturer = '' }) {
  return rows.filter(row => row.year === Number(year) && row.month === Number(month)
    && (!family || row.familia === family) && (!manufacturer || row.fabricante === manufacturer));
}

function sum(rows, key) {
  if (rows.some(row => row[key] == null)) return null;
  return Math.round(rows.reduce((total, row) => total + row[key], 0) * 100) / 100;
}

export function dailyShipping(rows, year, month, today = new Date()) {
  const now = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return Array.from({ length: new Date(year, month, 0).getDate() }, (_, index) => {
    const day = index + 1;
    const matches = rows.filter(row => row.day === day);
    const future = new Date(year, month - 1, day) > now;
    return { day, label: String(day).padStart(2, '0'), valorTotal: future && matches.length === 0 ? null : sum(matches, 'valorTotal') };
  });
}

export function currentWeekRange(today = new Date(), weekOffset = 0) {
  const start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() + weekOffset * 7);
  const end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6);
  const iso = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  return { dataInicial: iso(start), dataFinal: iso(end) };
}

export function weeklyShipping(rows, today = new Date(), weekOffset = 0) {
  const now = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() + weekOffset * 7);
  return WEEKDAYS.map((label, index) => {
    const date = new Date(start.getFullYear(), start.getMonth(), start.getDate() + index);
    const matches = rows.filter(row => row.year === date.getFullYear() && row.month === date.getMonth() + 1 && row.day === date.getDate());
    return { label, date: `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}`,
      valorTotal: date > now && matches.length === 0 ? null : sum(matches, 'valorTotal') };
  });
}

export function weeklyComparison(rows, today = new Date()) {
  const previous = weeklyShipping(rows, today, -1);
  return weeklyShipping(rows, today).map((row, index) => ({ ...row,
    valorAnterior: previous[index].valorTotal, dateAnterior: previous[index].date }));
}

export function groupShipping(rows, dimension) {
  const groups = new Map();
  rows.forEach(row => {
    const name = row[dimension] || 'Não informada';
    if (!groups.has(name)) groups.set(name, []);
    groups.get(name).push(row);
  });
  return [...groups].map(([name, matches]) => ({ name, valorTotal: sum(matches, 'valorTotal'),
    valorFrete: sum(matches, 'valorFrete'), valorLiquido: sum(matches, 'valorLiquido') }))
    .sort((a, b) => b.valorTotal - a.valorTotal || a.name.localeCompare(b.name, 'pt-BR'));
}
